import { render } from "./index.vue?vue&type=template&id=4bf5a8a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@/assets/css/newdesign.scss?vue&type=style&index=0&id=4bf5a8a6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf5a8a6"]])

export default __exports__